import React from 'react'
import { SupportBarWmo } from '@usap/widgets'
import {
  IcoMoon,
  EmptyCartWmoIcon,
} from '@usap/uicomponents'
import {
  StyledContainer,
  StyledEmptyCartContainer,
  StyledReturnHomeContainer,
  StyledSeparator,
  StyledTextContainer,
  StyledEmptyCartText,
  StyledReturnHomeText,
  SupportBarWrapper,
} from './EmptyCartWmo.css'

import OpenChat from '../../../Kustomer/Events'
import { useSparkChatEnabled } from '../../../../hooks'
import { openSparkChatModal } from '../../../../helpers'

// eslint-disable-next-line arrow-body-style
const EmptyCartWmo = () => {
  const isSparkChatEnabled = useSparkChatEnabled();

  const openChatHandler = () => {
    if(isSparkChatEnabled) {
      openSparkChatModal();
    } else {
      OpenChat();
    }
  }

  return (
    <StyledContainer data-testid="empty-cart-page">
      <StyledEmptyCartContainer>
        <IcoMoon icon={EmptyCartWmoIcon} />
        <StyledTextContainer gap="8px">
          <StyledEmptyCartText fontSize="24px" height="36px">
            Your Cart is Empty!
          </StyledEmptyCartText>
        </StyledTextContainer>
      </StyledEmptyCartContainer>

      <StyledReturnHomeContainer gap="4px">
        <StyledReturnHomeText
          fontWeight="600"
          height="20px"
          textDecoration="underline"
          as="a"
          href="/"
          data-testid="return-home-empty-cart-page"
        >
          Return Home
        </StyledReturnHomeText>
        <StyledReturnHomeText fontWeight="400" height="20px">
          to start shopping for the right part!
        </StyledReturnHomeText>
      </StyledReturnHomeContainer>
      <StyledSeparator gap="0px" />
      <SupportBarWrapper>
        <SupportBarWmo openChat={openChatHandler} />
      </SupportBarWrapper>
    </StyledContainer>
  )
}

export default EmptyCartWmo
